import { useEffect } from 'react';
import type { FC } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import {
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Typography,
} from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import {
  LoginAmplify,
  LoginAuth0,
  LoginFirebase,
  LoginJWT,
} from '../../../components/authentication/login';
import Logo from '../../../components/Logo';
import useAuth from '../../../hooks/useAuth';
import gtm from '../../../lib/gtm';

const platformIcons = {
  Amplify: '/static/icons/amplify.svg',
  Auth0: '/static/icons/auth0.svg',
  Firebase: '/static/icons/firebase.svg',
  JWT: '/static/logo_icon.png',
};

const Login: FC = () => {
  const { method } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
      <Helmet>
        <title>Login | Napoleao</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: 'background.default',
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
        }}
      >
        <Container
          maxWidth="sm"
          sx={{
            py: 0,
            my: 'auto',
          }}
        >
          <Box display="flex" justifyContent="center" mb={isMobile ? 3 : 8}>
            <RouterLink to="/">
              <Logo width={isMobile ? '350px' : '400px'} />
            </RouterLink>
          </Box>
          <Card>
            <CardContent
              sx={{
                display: 'flex',
                flexDirection: 'column',
                p: 4,
              }}
            >
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'space-between',
                  mb: 3,
                }}
              >
                <div>
                  <Typography color="textPrimary" gutterBottom variant="h4">
                    Gestor Napoleão
                  </Typography>
                  <Typography color="textSecondary" variant="body2">
                    Acesse a área restrita
                  </Typography>
                </div>
                <Box
                  sx={{
                    height: 32,
                    '& > img': {
                      maxHeight: '100%',
                      width: 'auto',
                    },
                  }}
                >
                  {/* @ts-ignore */}
                  <img alt="Auth platform" src={platformIcons[method]} />
                </Box>
              </Box>
              <Box
                mb={1}
                sx={{
                  flexGrow: 1,
                  mt: 3,
                }}
              >
                {method === 'Amplify' && <LoginAmplify />}
                {method === 'Auth0' && <LoginAuth0 />}
                {method === 'Firebase' && <LoginFirebase />}
                {method === 'JWT' && <LoginJWT />}
                <Box
                  sx={{
                    mt: 3,
                    textAlign: 'end',
                  }}
                >
                  <Button
                    color="primary"
                    variant="text"
                    onClick={() =>
                      navigate('/authentication/password-recovery')
                    }
                  >
                    Esqueci minha senha
                  </Button>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Container>
      </Box>
    </>
  );
};

export default Login;
